module.exports = __webpack_public_path__ + "img/inst3.51d0bdc4.png";